import { render, staticRenderFns } from "./PreviewHotel.vue?vue&type=template&id=070eb39d&scoped=true&"
import script from "./PreviewHotel.vue?vue&type=script&lang=js&"
export * from "./PreviewHotel.vue?vue&type=script&lang=js&"
import style0 from "./PreviewHotel.vue?vue&type=style&index=0&id=070eb39d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070eb39d",
  null
  
)

export default component.exports